<template>
  <div :class="$vuetify.breakpoint.smAndDown ? 'ml-0  mt-4' : 'mx-2'">
    <!-- Resgatar Token -->
    <div v-if="isLoggedIn" class="mx-2 mt-4 mb-10">
      <div class="d-flex align-center text-h5">
        <div>{{ $t("redeemToken") }}</div>
        <v-divider class="ml-5"></v-divider>
      </div>
      <div :class="$vuetify.breakpoint.smAndDown ? 'my-6' : 'd-flex mt-6'">
        <v-text-field
          v-model="token"
          ref="tokenInput"
          name="token"
          label="Token"
          clearable
          outlined
          tabindex="107"
          autocapitalize="off"
          type="text"
          :counter="8"
          maxlength="8"
          :rules="[rules.lengthToken]"
          :style="!$vuetify.breakpoint.smAndDown && 'max-width: 300px;'"
        ></v-text-field>
        <DialogConfirmToken
          type="playerPromotions"
          :token="token"
          :isValidToken="isValidToken"
          @emitMsgTokenAlert="emitMsgTokenAlert"
        />
      </div>
      <v-alert
        v-show="msgTokenAlert"
        type="warning"
        text
        dense
        border="left"
        :style="!$vuetify.breakpoint.smAndDown && 'max-width: 430px;'"
      >
        {{ msgTokenAlert }}
      </v-alert>
      <div>
        {{ $t("infoRedeemToken") }}
        <a href="/dashboard/promotions" style="text-decoration: none;">
          {{ $t("myPromotions") }}
        </a>
        .
      </div>
    </div>

    <!-- Title 'Promotions' -->
    <div class="d-flex align-center text-h5 mx-2 my-4">
      <div>{{ $t("promotions") }}</div>
      <v-divider class="ml-5"></v-divider>
    </div>

    <div
      v-if="promotionsFetched == false"
      :max-width="$vuetify.breakpoint.smAndDown ? 400 : ''"
      :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : ''"
    >
      <v-row>
        <v-col
          cols="12"
          xl="4"
          lg="4"
          md="4"
          sm="4"
        >
          <v-skeleton-loader
            type="card"
            class="mx-auto"
            />
        </v-col>
      </v-row>
    </div>

    <v-col v-else-if="noPromotions == true">
      <v-card class="pa-4 mx-auto colorDominant">
        <v-alert
          text
          class="ma-0"
          type="info"
          color="primary darken-2"
          border="left"
          dense
        >
          {{ $t("noPromotionForYou") }}
        </v-alert>
      </v-card>
    </v-col>

    <v-container
      v-else
      transition="fade-transition"
    >
      <v-row>
        <!-- card v-for -->
        <v-col v-for="(promotion, index) in promotions"
          :key="promotion.id"
          cols="12"
          xl="4"
          lg="4"
          md="4"
          sm="4"
        >
          <v-card
            class="colorDominant"
          >
            <template slot="progress">
              <v-progress-linear height="7" indeterminate></v-progress-linear>
            </template>

            <v-img
              aspect-ratio="2.571"
              :src="promotion.image"
              @error="
                imageError({
                  src: promotion.image,
                  index,
                  code: promotion.code_promo,
                })
              "
            >
              <div
                class="d-flex align-end justify-end pa-4"
                style="height: 100%;"
              >
                <v-tooltip
                  v-if="promotion.product_type == 'casino'"
                  bottom
                  content-class="tooltipGames"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="d-flex justify-center"
                    >
                      <v-icon
                        color="primary"
                        style="
                          background-color: #212121;
                          border-radius: 100%;
                          border: none;
                          width: 30px;
                          height: 30px;
                        "
                        v-bind="attrs"
                        v-on="on"
                        large
                      >
                        mdi-plus-circle-outline
                      </v-icon>
                    </div>
                  </template>
                  <span>{{ $t("includedGames") }}:</span>
                  <ul>
                    <li v-for="game in promotion.games" :key="game.game_name">
                      {{ game.game_name }}
                    </li>
                  </ul>
                </v-tooltip>
              </div>
            </v-img>
  
            <div class="pa-4 backgroundFade">
              <v-card-title class="d-block text-truncate pa-0">
                {{ promotion.titulo }}
              </v-card-title>
              
              <v-card-text class="pa-0">
                <div class="d-flex justify-space-between align-center" style="margin-bottom: 16px;">
                  <div
                    v-if="promotion.product_type == 'sportbook'"
                    class="d-flex align-center"
                    style="color: LimeGreen; height:45px;"
                  >
                    {{
                      $t("promotionMaxBonus", {
                        max_bonus:
                          promotion.bonus_max && Number(promotion.bonus_max) > 0
                            ? promotion.bonus_max
                            : promotion.bonus,
                      })
                    }}
                  </div>
                  <div
                    v-else
                    class="d-flex align-center"
                    style="
                      color: LimeGreen;
                      gap: 4px;
                      height:45px;
                    "
                  >
                    <div class="d-flex" style="gap: 4px">
                      <div>
                        {{ $t("roundsQuantity") }}:
                        {{ promotion.casino_freespins_qty }}
                      </div>
                      <div>
                        <v-tooltip
                          top
                          content-class="tooltip"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="info"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("roundsQuantityTip") }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                  <v-chip
                    filter
                  >
                  <div>
                    <div class="mr-2 d-flex align-center" v-if="$permissions().customIcons.appbar">
                      <img :src="getImageSrc(promotion.product_type)" width="22px">
                    </div>
                    <div class="mr-2 d-flex align-center" v-else>
                      <v-icon>{{ getIconName(promotion.product_type) }}</v-icon>
                    </div>
                  </div>
                    {{ promotion.product_type === 'casino' ? $t("casino") : $t("sports") }}
                  </v-chip>
                </div>
  
    
                <div
                  class="
                    description-opacity
                    mb-1
                    twoLinesTruncate
                  "
                  style="height: 40px"
                >
                  {{ promotion.descricao }}
                </div>
              </v-card-text>
    
              <v-card-actions class="pa-0">
                <v-btn
                  @click="promotionDetail(promotion)"
                  block
                  class="primary"
                >
                  {{ $t("knowMore") }}
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { validate } from "@/util/form-validate";
import DialogConfirmToken from "../../../components/promotions/dialog-confirm-token.vue";

export default {
  name: "PlayerPromotions",

  components: { DialogConfirmToken },

  data: () => ({
    promotions: [],
    noPromotions: false,
    promotionsFetched: false,
    possibleExtensions: ["png", "jpg", "jpeg", "webp"],
    // Resgate ao token
    token: "",
    rules: {
      lengthToken: validate.lengthToken,
    },
    isValidToken: false,
    msgTokenAlert: "",
  }),

  created() {
    this.fetchPromotions();
  },

  watch: {
    token() {
      this.isValidToken = this.$refs.tokenInput.validate();
      this.msgTokenAlert = "";
    },
  },

  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    skeletonPerCol() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "xs") {
        return 1;
      } else if (breakpoint == "md") {
        return 2;
      } else if (breakpoint == "lg") {
        return 2;
      } else if (breakpoint == "xl") {
        return 3;
      }
      return 1;
    },

    isLoggedIn() {
      return this.$store.state.logged.status;
    },
  },

  methods: {
    fetchPromotions() {
      if (this.isLoggedIn) {
        this.fetchLoggedUserPromotions();
      } else {
        this.fetchUnloggedAvailablePromotions();
      }
    },
    fetchUnloggedAvailablePromotions() {
      this.$axios
        .post(
          "/promotion/listAvailables",
          this.$formdata({ domain: this.$domain() })
        )
        .then((res) => {
          this.noPromotions = false;

          const data = res.data.dados.filter(
            (promotion) => promotion.hide !== "1"
          );

          if (data.length === 0) {
            this.noPromotions = true;
            this.promotions = [];
            return;
          }

          this.promotions = data.map((promotion) => ({
            ...promotion,
            image: encodeURI(
              `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${
                promotion.code_promo
              }.${this.possibleExtensions[0]}`
            )
          }));
        })
        .catch(() => {
          this.noPromotions = true;
        })
        .finally(() => {
          this.promotionsFetched = true;
        });
    },
    fetchLoggedUserPromotions() {
      this.$axios
        .get("/player/bonus/promotion/listAvaliable")
        .then((res) => {
          this.noPromotions = false;

          const data = res.data.dados.filter(
            (promotion) => promotion.hide !== "1"
          );

          this.promotions = data.map((promotion) => ({
            ...promotion,
            image: encodeURI(
              `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${
                promotion.code_promo
              }.${this.possibleExtensions[0]}`
            )
          }));
          if (this.promotions.length === 0) {
            this.noPromotions = true;
          }
        })
        .catch(() => {
          this.noPromotions = true;
        })
        .finally(() => {
          this.promotionsFetched = true;
        });
    },
    promotionDetail(promotion) {
      this.$router.push({
        path: `/promotions/${promotion.id}`,
      });
    },
    imageError({ src, index, code }) {
      let currExtension = src.split(".")[src.split(".").length - 1];
      let currExtensionIndex = this.possibleExtensions.indexOf(currExtension);
      let nextExtensionIndex = currExtensionIndex + 1;

      if (nextExtensionIndex == this.possibleExtensions.length) {
        return;
      }

      let nextExtension = this.possibleExtensions[nextExtensionIndex];

      this.promotions[index].image = encodeURI(
        `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${code}.${nextExtension}`
      );
    },
    emitMsgTokenAlert(val) {
      this.msgTokenAlert = val;
    },
    getImageSrc(typePromo) {
        const domain = this.$domain;
        const baseUrlS3 = `https://dozr8la71aog.cloudfront.net/domains/${domain()}/img/custom/icons/appbar`;
        const images = {
          casino: `${baseUrlS3}/cassino50.png`,
          sportbook: `${baseUrlS3}/sports50.png`,
        };
        return images[typePromo] || '';
      },
      getIconName(typePromo) {
        const icons = {
          casino: 'mdi-slot-machine-outline',
          sportbook: 'mdi-soccer',
        };
        return icons[typePromo];
      },
  },
};
</script>

<style>
.tooltip {
  width: 200px;
}
.tooltipGames {
  width: 250px;
  padding: 16px;
  opacity: 1;
}

.description-opacity {
  color: rgba(163, 163, 163, 1);
}

.backgroundFade {
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) -16.67%,
    #000000 99.99%,
    #313131 100%
  );
}

.twoLinesTruncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1rem;
}
</style>